import React, { Component } from 'react'
import PlusIcon from '../../icons/plusicon';
import SearchIcon from '../../icons/searchicon';
import FilterActiveIcon from '../../icons/filteractiveicon';
import FilterIcon from '../../icons/filtericon';
import { Link } from 'react-router-dom';
import ReactPaginate from "react-paginate";
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import service from '../../services';
import { ActCreators } from '../../redux/bindActionCretor';
import Loader from '../../component/loader';
import ErrorPopUp from '../../component/errorPopUp';
import moment from 'moment';

let statusFilterList = []

const mapStateToProps = state => ({
    pageTakeoverEditId: state.pageTakeoverEditId,
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};

let sub;
class PageTakeoverList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loaderFlag: false,
            offset: 0,
            perPage: 20,
            pageCount: 0,
            currentPage: 0,
            searchField: '',
            statusArray: [
                { assign: "Live", list: "active", value: false },
                { assign: "Disable", list: "inactive", value: false },
            ],
            pageTakeoverList: [],
            errorPopup: false,
            errorMsg: '',
        }
        this.apiserve = new service();
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
        statusFilterList = []
    };

    componentDidMount() {
        this.getPageTakeoverList(1, this.state.perPage)

        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "pageTakeOver|getAllList":
                    if (!response.error) {
                        this.setState({
                            pageTakeoverList: response?.data?.data || [],
                            pageCount: response?.data?.pagination?.totalPages || 0,
                            loaderFlag: false
                        })
                    }
                    break;
                default:
                    break;
            }
        })
    }

    getPageTakeoverList = (skip, limit) => {
        let data = {}
        data.page = skip
        data.limit = limit
        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }
        if (statusFilterList && statusFilterList.length) {
            data.status = statusFilterList
        }
        this.setState({ loaderFlag: true })
        this.apiserve.sendevent("pageTakeOver|getAllList", data)
    }

    onSearchFilter = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            currentPage: 0
        }, () => {
            if (this.searchDebounce) clearTimeout(this.searchDebounce);
            this.searchDebounce = setTimeout(() => {
                this.getPageTakeoverList(1, this.state.perPage)
            }, 500);
        })
    }

    StatusFilter = (e, selectedIndex, isClearStatusType = false) => {
        let index = selectedIndex
        let event = e && e.target && e.target.checked
        let approvePassList = [...this.state.statusArray]

        approvePassList.forEach((item, i) => {
            if (i === index) {
                approvePassList[i].value = event
            }
            if (isClearStatusType) {
                approvePassList[i].value = false
                statusFilterList = []
            }
        })
        this.setState({
            ...this.state,
            statusArray: approvePassList,
            currentPage: 0
        }, () => {
            if (event) {
                if (index !== null) {
                    statusFilterList = [...statusFilterList, this.state.statusArray[index].list];
                }
            } else {
                if (index !== null) {
                    let tempArray = statusFilterList.filter((d) => d !== this.state.statusArray[index].list);
                    statusFilterList = tempArray;
                }
            }
            this.getPageTakeoverList(1, this.state.perPage)
        })
    }

    handlePageClick = (e) => {
        const selectedPage = e.selected;
        const offset = selectedPage + 1;
        this.setState(
            {
                currentPage: selectedPage,
                offset: offset,
            },
            () => {
                this.getPageTakeoverList(offset, this.state.perPage)
            }
        );
    }

    AddPageTakeover = () => {
        this.props.PageTakeoverEditData("")
        this.props.history.push('/create-page-takeover');
    }

    ViewPageTakeover = (id) => {
        this.props.PageTakeoverEditData(id)
        this.props.history.push('/page-takeover-view/' + id);
    }

    errorMsgPopup = () => {
        this.setState({ errorPopup: false })
    }

    render() {
        const { pageTakeoverList } = this.state;
        return (
            <div className="right_side_wrapper">
                <ul className="fpg_admin_tab disp_flex">
                    <li className="active">
                        <p className="uppercase text_left">
                            <div>PAGE TAKEOVER LIST</div>
                            <span onClick={this.AddPageTakeover}><PlusIcon /></span>
                        </p>
                    </li>
                </ul>
                <div className="dashboard_header no_bg p_0 mt_10 mb_10">
                    <div className="searchBlock back_date pl_15">
                        <form onSubmit={e => { e.preventDefault(); }} className="m_0">
                            <input
                                className="bg_white"
                                type="text"
                                autoComplete="false"
                                placeholder="Search"
                                id="searchField"
                                name="searchField"
                                value={this.state.searchField}
                                onChange={this.onSearchFilter}
                            />
                            <button type='button' style={{ pointerEvents: 'none' }}>
                                <SearchIcon />
                            </button>
                        </form>
                    </div>
                </div>
                <div className="table_wrap dashboard_data film_list_table striped_table page_takeover_list">
                    <table>
                        <thead>
                            <tr>
                                <th style={{ width: "200px" }} className='email_d'>Name</th>
                                <th style={{ width: "180px" }}>Display Pages</th>
                                <th style={{ width: "140px" }}>Start Date</th>
                                <th style={{ width: "140px" }}>End Date</th>
                                <th style={{ width: "100px" }}>Displays</th>
                                <th style={{ width: "120px" }}>
                                    <span className="disp_flex d_flex_align_center">
                                        Status
                                        {statusFilterList && statusFilterList.length ?
                                            <FilterActiveIcon />
                                            :
                                            <FilterIcon />
                                        }
                                    </span>
                                    <div className="tabelData_popup" style={{ left: "0" }}>
                                        <form>
                                            <div className="customCheck">
                                                <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                                                    <p className="link" onClick={() => this.StatusFilter(null, null, true)}>Clear All</p>
                                                </div>
                                                <div className="customCheckBox">
                                                    {this.state.statusArray.map((item, i) => (
                                                        <div className="customCheckBox" key={i}>
                                                            <input
                                                                type="checkbox"
                                                                id={'status' + item.list}
                                                                name={'status' + item.list}
                                                                value={item.list ? true : false}
                                                                checked={item.value ? true : false}
                                                                onClick={(e) => this.StatusFilter(e, i)}
                                                            />
                                                            <label htmlFor={'status' + item.list}>{item.assign}</label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {pageTakeoverList && pageTakeoverList.length > 0 && pageTakeoverList.map((item) => {
                                return (
                                    <tr key={item._id} onClick={() => this.ViewPageTakeover(item.id)} className={`pointer ${item.status === 'active' ? '' : 'disable'}`}>
                                        <td style={{ width: "200px" }} className='email_d'>
                                            <strong>{item.name}</strong>
                                        </td>
                                        <td style={{ width: "180px" }}>
                                            <div className="display_pages_tags">
                                                {item.displayPages && item.displayPages.map((page, i) => (
                                                  <span key={i} className="page_tag">{page}</span>
                                                ))}
                                           </div>
                                        </td>
                                        <td style={{ width: "140px" }}>
                                            {item.startDatetime && item.startDatetime.enabled && item.startDatetime.datetime
                                                ? moment(item.startDatetime.datetime).format('MM/DD/YY h:mm A')
                                                : "Immediate"}
                                        </td>
                                        <td style={{ width: "140px" }}>
                                            {item.endDatetime && item.endDatetime.enabled && item.endDatetime.datetime
                                                ? moment(item.endDatetime.datetime).format('MM/DD/YY h:mm A')
                                                : "No End"}
                                        </td>
                                        <td style={{ width: "100px" }}>
                                            {item.distinctDisplays && item.distinctDisplays.unlimited
                                                ? "Unlimited"
                                                : (item.distinctDisplays && item.distinctDisplays.max) || 1}
                                        </td>
                                        <td style={{ width: "120px" }}>
                                            <div>
                                                <p>{item.status === 'active' ? 'Live' : 'Disabled'}</p>
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>

                    {pageTakeoverList && pageTakeoverList.length === 0 && !this.state.loaderFlag &&
                        <div className="no_data_found text_center" style={{ padding: '40px' }}>
                            <p>No page takeovers found</p>
                        </div>
                    }

                    {this.state.pageTakeoverList && this.state.pageTakeoverList.length ?
                        <div className="custom-pagination">
                            <ReactPaginate
                                previousLabel={""}
                                nextLabel={""}
                                breakLabel={"..."}
                                breakClassName={"break-me"}
                                pageCount={this.state.pageCount}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={this.handlePageClick}
                                containerClassName={"pagination"}
                                subContainerClassName={"pages pagination"}
                                activeClassName={"active"}
                                forcePage={this.state.currentPage}
                            />
                        </div>
                        : ''
                    }

                    {this.state.errorPopup ?
                        <ErrorPopUp
                            errorMsg={this.state.errorMsg}
                            errorMsgPopup={this.errorMsgPopup}
                        />
                        : ''
                    }

                    {this.state.loaderFlag ? (
                        <Loader />
                    ) : (
                        ""
                    )}
                </div>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PageTakeoverList)
